import React, { useEffect } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { commonUtils } from 'redux/_common';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { useParams } from 'react-router-dom';
import MarpolModule from './MarpolModule';
import Frame from 'react-frame-component';
import { getInitialContent } from 'redux/app/vessel/inspector/utils';
import { marpolActions } from 'redux/app/marpol';

type OwnProps = {
    iframeRef: any;
    bookId: string;
};
type MarpolInspectorViewProps = PropsFromRedux & OwnProps;

const timeNow = moment().format('DD/MM/YYYY HH:mm');

function MarpolInspectorView(props: MarpolInspectorViewProps) {
    const { iframeRef, bookId, showCoverPages, stateOfScriptInjection } = props;
	const params = useParams<{vesselId: string}>();
	const { vesselId } = params; 

    const marpolBookIdsForWhichWeNeedToLoadTanks = [
        'ORB4',
        'CRB',
        'BALLAST',
        // 'ANNEX6V2',
    ];
    useEffect(() => {
        if (marpolBookIdsForWhichWeNeedToLoadTanks.includes(bookId)) {
            props.loadTanks(vesselId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookId]);

    async function injectScriptAndStyle() {
        if (bookId) {
            console.log('Running Iframe - MarpolInspectorView...');
            // insert script tag to iframe
            const iframe = iframeRef.current;
            const iframeHeadElem = iframe && iframe.contentDocument.head;
            // if script with id 'pagedjsScript' already exists
            if (
                iframeHeadElem &&
                iframeHeadElem.querySelector('#pagedjsScript')
            ) {
                // delete script tag with id 'pagedjsScript'
                console.log('Deleting pagedjs script tag from iframe...');
                const script = iframeHeadElem.querySelector('#pagedjsScript');
                script?.remove();
            }

            // insert script tag to iframe
            console.log('Inserting pagedjs script tag to iframe...');

            console.log({ iframeHeadElem });

            const script = document.createElement('script');
            script.id = 'pagedjsScript';
            script.src = `/paged.js`;
            // defer
            script.defer = true;
            iframeHeadElem.appendChild(script);

            // run preview script on load
            const script2 = document.createElement('script');
            script2.innerHTML = `window.PagedConfig = {
            auto: false,
        };
        `;

            iframeHeadElem.appendChild(script2);
        }
    }

    useEffect(() => {
        // INFO: Onlcy once user clicks on the YES(show cover pages), the Iframe component gets created.
        // So injection of styles takes place only after user clicks.
        if (stateOfScriptInjection === 'ACTIVE' && showCoverPages) {
            setTimeout(() => {
                injectScriptAndStyle();
            }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookId, stateOfScriptInjection, showCoverPages]);

    const printIframe = async (id: string) => {
        // @ts-ignore
        const iframe = document.frames
            ? // @ts-ignore
              document.frames[id]
            : document.getElementById(id);
        const iframeWindow = iframe.contentWindow || iframe;

        console.log('Print button clicked, previewing...');
        // preview
        await (iframeWindow as any)?.PagedPolyfill?.preview();

        iframe.focus();
        iframeWindow.print();

        return false;
    };

    const resetIframe = (id: string) => {
        // @ts-ignore
        const iframe = document.frames
            ? // @ts-ignore
              document.frames[id]
            : document.getElementById(id);
        const iframeWindow = iframe.contentWindow || iframe;

        console.log('Reset button clicked, resetting...');

        if (iframe && iframe.contentDocument && iframe.contentDocument.body) {
            // clear contents of element with id as mountHere
            const mountHere =
                iframe.contentDocument.body.querySelector('#mountHere');

            if (mountHere) {
                mountHere.innerHTML = '';
            }
        }
        // reset
        // (iframeWindow as any)?.PagedPolyfill?.reset();

        // iframe.focus();
        // iframeWindow.print();

        // return false;
    };

    // INFO: When user clicks on the "NO" button on print icon click modal, then it moves into state of active & ended
    if (
        stateOfScriptInjection === 'ACTIVE' ||
        stateOfScriptInjection === 'ENDED'
    ) {
        return (
            <Frame
                key={bookId}
                width={'100%'}
                height={'1000px'}
                ref={iframeRef}
                initialContent={getInitialContent(bookId, timeNow)}
                mountTarget="#mountHere"
                id="printIframe"
            >
                <MarpolModule vesselId={vesselId} showCoverPages={showCoverPages} bookId={bookId} />
            </Frame>
        );
    }

    // INFO: when user clicks "YES" in the modal
    return (
        <div ref={iframeRef}>
            <MarpolModule vesselId={vesselId} showCoverPages={false} bookId={bookId} />
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const showCoverPages = inspectorSelectors.getShowCoverPages(inspectorStore);
    const stateOfScriptInjection =
        inspectorSelectors.getStateOfScriptInjection(inspectorStore);
    return {
        showCoverPages,
        stateOfScriptInjection,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {
        loadTanks(vesselId: string) {
            return dispatch(marpolActions.commands.settingsLoad(vesselId));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(MarpolInspectorView);
